module.exports = require("@swa-ui/core/src/DateSelector/Calendar.module.scss");